
// @ts-nocheck
import locale_tr_46js_423f1a06 from "#nuxt-i18n/423f1a06";
import locale_en_46js_d4c72030 from "#nuxt-i18n/d4c72030";

export const localeCodes =  [
  "tr",
  "en"
]

export const localeLoaders = {
  tr: [
    {
      key: "locale_tr_46js_423f1a06",
      load: () => Promise.resolve(locale_tr_46js_423f1a06),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46js_d4c72030",
      load: () => Promise.resolve(locale_en_46js_d4c72030),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "tr",
      iso: "tr-TR",
      name: "Türkçe",
      dir: "ltr",
      default: true,
      files: [
        {
          path: "/Users/demir/projects/inanctur/inanctur.com.tr/i18n/locale/tr.js",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      iso: "en-US",
      name: "English",
      dir: "ltr",
      files: [
        {
          path: "/Users/demir/projects/inanctur/inanctur.com.tr/i18n/locale/en.js",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "tr",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "locale/",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "https://inanctur.com.tr",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "tr",
    iso: "tr-TR",
    name: "Türkçe",
    dir: "ltr",
    default: true,
    files: [
      {
        path: "/Users/demir/projects/inanctur/inanctur.com.tr/i18n/locale/tr.js",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    iso: "en-US",
    name: "English",
    dir: "ltr",
    files: [
      {
        path: "/Users/demir/projects/inanctur/inanctur.com.tr/i18n/locale/en.js",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/